const Footer = () => {
	return (
		<>
			{/*   */}
			<div className='w-343 h-352 md:w-690 md:h-352 xl:w-1110 xl:h-320 mt-100 md:mt-120 mb-40 md:mb-56 md:mt-56 py-50 md:pt-56 md:pb-64 px-24 md:px-75 flex flex-col xl:flex-row items-center justify-between bg-black rounded-lg'>
				<div className='w-full xl:w-540 xl:h-159 flex flex-col xl:items-start xl:justify-between'>
					<h2 className='font-bold text-26 md:text-32 xl:text-40 leading-33 md:leading-40 xl:leading-50 text-light_cream text-center xl:text-left'>
						Book a call with me
					</h2>
					<p className='font-medium text-16 md:text-18 leading-26 md:leading-28 text-light_cream text-center xl:text-left'>
						I’d love to have a chat to see how I can help you. The best first step is for us to
						discuss your project during a free consultation. Then we can move forward from there.
					</p>
				</div>
				<button className='w-176 md:w-228 h-44 md:h-56 text-14 md:text-16 leading-28 text-light_cream bg-light_red hover:bg-summer_yellow rounded-full'>
					Free Consultation
				</button>
			</div>

			<footer className='w-full h-12 md:h-16 flex items-center justify-between'>
				<div className='w-12 h-12 md:w-16 md:h-16 bg-logo bg-center bg-cover' />
				<div className='w-44 h-44 md:w-228 md:h-14 bg-black hover:bg-galactic_blue hover:cursor-pointer flex items-center justify-center rounded-full'>
					<p className='font-bold text-14 md:text-16 leading-28 text-light_cream '>
						Free Consultation
					</p>
				</div>
			</footer>
		</>
	);
};

export default Footer;
